import apiClient from '../client';
import type { TenderAPIV2 } from '../../types';

// NOTE: `baseURL` override is a temporary workaround until the apiClient is
// refactored to use `/api` as base and embed the version in the path.
// Track the cleanup separately; do not extend this pattern elsewhere.
const V2_BASE = '/api/v2';

/**
 * Fetch a tender by ID.
 * Returns `null` if the backend responds 404 (tender does not exist).
 * Any other non-2xx response is thrown by the apiClient interceptor.
 */
export async function fetchTenderV2(tenderId: string): Promise<TenderAPIV2 | null> {
  const response = await apiClient.get<TenderAPIV2>(`/tenders/${tenderId}`, {
    baseURL: V2_BASE,
    validateStatus: (status) => status === 200 || status === 404,
  });
  if (response.status === 404) return null;
  return response.data;
}
